import React, { Component } from 'react';
import Logo from "../../assets/Logo.png";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { Tooltip, WithTooltip } from '@abb/abb-common-ux-react';
import IThresholdSettings from '../../models/settings/ThresholdSettings';
import { POSITION_REPORT } from '../../utilities/Constants';

interface IReportProps {
    sampleData: any;
    reportDate: any;
    thresholdSettings: IThresholdSettings[];
}

export default class ReportHeader extends Component<IReportProps> {
    checkIfImageExists = async (url: any) => {
        const img = new Image();
        img.src = url;

        if (await img.complete) {
            return true;
        } else {
            img.onload = () => {
                return true;
            };

            img.onerror = () => {
                return false;
            };
        }
    };
    render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <div>
                                
                                <div className="float-left">
                                <div className="report-title font-weight-bolder">{t(this.props.sampleData?.reportType)}</div>
                                    <div>{this.props.reportDate}</div>
                                </div>
                                <div className="float-right">
                                    {this.checkIfImageExists(
                                        `${window.LMS.SAMPLE_API_URL}/Settings/General/logo`
                                    ) ? (
                                        <img
                                            src={`${window.LMS.SAMPLE_API_URL}/Settings/General/logo`}
                                            alt={`${window.LMS.SAMPLE_API_URL}/Settings/General/logo`}
                                            style={{ height: 70, width: 100 }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="clearfix" />
                                <hr className="hr-line" />
                                <div className="report-details pl-3 pr-3">
                                    <div className="row mt-2 report-details mb-2 ">
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.MODULE_SAMPLE + " " + CONSTANTS.LABLE_NAME)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.name}
                                            </span>
                                        </div>
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.MODULE_SOURCE) + " " + t(CONSTANTS.LABLE_NAME)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.sourceName}
                                            </span>
                                        </div>
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.MODULE_PRODUCT) + " " + t(CONSTANTS.LABLE_NAME)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.productName}
                                            </span>
                                        </div>
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.LABEL_ORDERID)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.orderId}
                                            </span>
                                        </div>
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.LABEL_SETID)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.setId}
                                            </span>
                                        </div>
                                        <div className="fl">
                                            <span className="summary-label">
                                                {t(CONSTANTS.SAMPLE_DATE)}:
                                            </span>
                                            <span className="summary-value ml-2">
                                                {this.props.sampleData?.formatedDate ??''}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                                <div className="mt-2 mb-2" style={{ display: "flex", alignItems: "baseline" }}>
                                    <span className="summary-label mr-2" style={{ width: 'auto' }}>
                                        {t(CONSTANTS.LABEL_REMARKS)}:
                                    </span>
                                    <WithTooltip>
                                        <span className="summary-value">
                                            {this.props.sampleData?.description}
                                        </span>
                                        <Tooltip style={{ width: this.props.sampleData?.description?.length > 200 ? "85vw" : "auto" }}>
                                            <span> {this.props.sampleData?.description}</span>
                                        </Tooltip>
                                    </WithTooltip>
                                </div>
                                <hr className="hr-line" />
                                <div className="clearfix" />
                            </div>
                            <div className="clearfix" />
                            <React.Fragment><div className="fr">
                                {this.props?.thresholdSettings?.map((th: IThresholdSettings, i: number) => {
                                    return th.key === 'RJLT' || th.key === 'ALLT2' || th.key === 'ALLT1' ? <div className="fl threshold" key={i}>
                                        <div className="fl threshold-box" style={{ background: th?.colorCode }} />
                                        <span className="fl threshold-text">{t(th?.name)} </span></div> : ""
                                })
                                }
                            </div>
                                <div className="clearfix" />
                            </React.Fragment>
                        </React.Fragment>
                }
            </Translation>
        )
    }
}